<template>
  <v-dialog
    id="warning-dialog"
    ref="warningdialog"
    @input="!toggleWarning && resolveWarning()"
    v-model="toggleWarning"
    width="400">
    <v-card>
      <v-card-title
        class="headline px-2 py-2"
        primary-title
        v-if="warningTitle"
        v-html="warningTitle">
      </v-card-title>

      <div v-html="warningMsg" class="px-2 pb-2"></div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          type="button"
          color="primary"
          @click="toggleWarning = false;">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'WarningDialog',
  data() {
    return {
      warningTitle: '',
      warningMsg: '',
      toggleWarning: false,
    };
  },
  methods: {
    resolveWarning() {
      this.toggleWarning = false;
      this.warningTitle = '';
      this.warningMsg = '';
      this.$root.$emit('hide-warning');
    },
  },
  created() {
    this.$root.$on('show-warning', (data) => {
      this.toggleWarning = true;
      this.warningTitle = data.title;
      this.warningMsg = data.msg;
    });
  },
};
</script>
